import * as asn1js from "asn1js";
import { Certificate } from "pkijs";
import countries from '../language/countries';

export async function getCountryCA() {
        try {
            const response = await fetch(window.netcopkiurlid + '/servlet/caCert');
            if (!response.ok) throw new Error('Network response was not ok');
            const arrayBuffer = await response.arrayBuffer();

            // Parsear el certificado
            const asn1 = asn1js.fromBER(arrayBuffer);
            const cert = new Certificate({ schema: asn1.result });

            // Buscar el atributo C (país) en el subject
            const countryAttr = cert.subject.typesAndValues.find(
                attr => attr.type === "2.5.4.6"
            );
            if (countryAttr) {
                const country = countryAttr.value.valueBlock.value;
                return country;
            }
            console.warn('No se pudo extraer el país del certificado');
            return null;
        } catch (error) {
            console.error('Error obteniendo el certificado de la CA:', error);
            return null;
        }
    }

export async function getAreaCode() {
    const countryCode = await getCountryCA();
    const country = countries.find(c => c.code === countryCode);

    if (country && country.dialcode) {
        return `${country.dialcode}`;
    } else {
        return '';
    }
}